import React from 'react'
import { useSelector } from 'react-redux'
import { Chip } from '@mui/material'

import { RootState } from '~redux/rootReducer'

import { AIPhoneLineType, getPhoneLineTypeDisplay } from './AIPhoneLineDialog'

const getDisplayAttributes = (type: string): [string, string, string] => {
  switch (type) {
    case 'CHAT':
    case 'ChatChat':
      return ['Chat', 'var(--paleblue)', 'var(--blue)']
    case 'VOICE':
    case 'ChatVoice':
      return ['Voice', '#F0EBF7', '#7B5EA7']
    case 'SEARCH':
    case 'ChatSearch':
      return ['Search', 'var(--backgroundgreen)', 'var(--green)']
    case 'SMS':
    case 'ChatSMS':
      return ['SMS', 'var(--pink02)', 'var(--pink)']
    case 'EMAIL':
      return ['Email', 'var(--offwhite)', 'var(--black)']
    default:
      return [type, 'var(--offwhite)', 'var(--black)']
  }
}

export const AIInteractionTypeChip: React.FC<{
  type: string
  phoneLineType?: string
}> = ({ type, phoneLineType }) => {
  const isSuper = useSelector((state: RootState) => state?.auth?.user?.super)
  const [displayType, bgcolor, color] = getDisplayAttributes(type)
  const isVoiceAI = type === 'VOICE' || type === 'ChatVoice'

  let displayText = displayType
  if (isVoiceAI && isSuper) {
    displayText = `Voice: ${getPhoneLineTypeDisplay(phoneLineType ? (phoneLineType as AIPhoneLineType) : 'STABLE')}`
  }

  return (
    <Chip
      label={displayText}
      sx={{
        backgroundColor: bgcolor,
        color: color,
      }}
      size='small'
    />
  )
}
